import {
  getCategoryTree,
  getCompanyCategory,
  getSubAccount,
  getItemBasePage,
  getItemBaseSkuPage,
  getItemBaseDetail,
  editItemBaseDetail,
  updateBatchState,
  updateBatchCategory,
  delBatch,
  putBatch,
  publishItems,
  publishItemsResult,
  getMainCategory,
  setMainCategory,
  getPlatformCategoryTree,
  queryFxgDetail,
  queryFxgCategoryProperties,
  editFxgDetail,
  queryCommonlySpecifications,
  editCommonlySpecifications,
  deleteCommonlySpecifications,
  pinyin,
  queryStockList,
  groupOnShelf,
  getSkus,
  getSupplierSkus,
  detailByBaseItemIds,
  distributorDetail,
  getWarning,
  findgoodscategory,
  supplierAdd,
  cgSupplierList,
  queryCategoryList,
  syncPlatformItem,
  batchSyncPlatformItem,
  queryErpItems,
  checkOuterIdRepeat,
  checkDistributionOuterId,
  getPriceAndStock,
  getSkuListByJd,
  queryPieceItemSkuList,
  checkSyncItems,
  checkSyncMarketItems,
  submitSyncItemTask,
  batchUpdatePrivacy,
  batchUpdateTitle,
  batchUpdateTitleProgress,
  itemStockQueryStockList,
  queryItemSkuSalesPrice,
  queryKmtErpItem,
  queryItemMatchFxReleation,
  autoBindKmtItem,
  manualBindKmtItem,
  platformItemReleation,
  platformItemSkuReleation,
  submitChangeKmtErpItem,
  // categoryAndPropertiesMatch,
  updateAutoSyncCategoryToKmt,
  queryAutoSyncCategoryToKmt,
  fastMergePlatformItem,
  fastMergePlatformItemProgress,
  secConfirmationItemV2,
  supplierQueryItemMatchFxReleation,
  getPublishCartList,
  copyPlatformInfoApi,
  getEditItemLinkList,
  getBaseItemErpStockList,
  getBaseItemSkuErpStockList,
  getBaseItemOrderNumList,
  getBaseItemSkuOrderNumList,
  shopGoodsGetItemDetail,
  sizeMapping,
  queryDuplicateGroupList,
  mergeDuplicateItems,
  deleteRepeatItems as deleteRepeatItemsApi,
  getRepeatItemIds
  , batchUpdateNotPublishPlatform as batchUpdateNotPublishPlatformApi,
  batchResizeImages,
} from "@/api/prod/center";
import {
  setDistributionGoods,
  distributionGoodsList,
  batchEditDistributionPrice,
  findItemDistributionPrice,
  itemSkusDistributionPriceSave,
  getKmtfxSupplierItemList,
  checkDownloadAutoJoinShopApi
} from "@/api/supplier/index";
import {
  distributorPublish,
  batchDistributorPublish,
  detailByBaseItemId,
  queryJobResult,
  displayGoodsList,
  itemDistributorPage,
  itemDistributorPageSku,
  joinDistributorItem,
  joinDistributorItemResult,
  supplierPromotionShopItemList,
  tradeChangeSupplierPromotionShopItemList,
  distributionItemTransformNormalItem,
  generateQrCodeUrl,
  sharePromotionShopItemList,
  getTotalSkuExtApi,
  markMainImagesChangeApi,
  batchUpdateMainImagesApi,
  skuInfoListApi,
  batchEditItemPicApi,
} from "@/api/distributor/index"
import { _filterInvalidImg } from "./kuaishou.js";
import { publishLimit,safeStringify,safeParse } from '@/utils/index.js';
import store from "@/store/index.js";
import dayjs from "dayjs";
import _, { cloneDeep, result } from "lodash";

// 获取erp商品可用库存
export function getErpStock2(data) {
  return itemStockQueryStockList(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    } else {
      return false;
    }
  });
}

// 规格价格预览销售价
export function preViewSalePrice(data) {
  return queryItemSkuSalesPrice(data).then((res) => {
    if (res.result === 1) {
      return res.data || [];
    } else {
      return [];
    }
  });
}

// 获取erp商品库存
export function getErpStock(data) {
  return queryStockList(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    } else {
      return false;
    }
  });
}

// 分销商品转平台资料
export function getDistributionItemTransformNormalItem(data) {
  return distributionItemTransformNormalItem(data).then((res) => {
    if (res.result === 1) {
      return res.data || false;
    } else {
      return false;
    }
  });
}

// 匹配ERP系统资料 在保存前调用
export function getErpItems(data) {
  const _data = _formatGoodsItem(data, true);
  return queryErpItems(_data).then((res) => {
    if (res.result === 1) {
      return mapErpItems(res.data);
    } else {
      return false;
    }
  });
}

// 校验系统资料重复编码
export function getCheckOuterIdRepeat(data) {
  const _data = _formatGoodsItem(data, true);
  return checkOuterIdRepeat(_data).then((res) => {
    if (res.result === 1) {
      return res.data;
    } else {
      return false;
    }
  });
}

// 重复清理：获取重复分组列表
export function getDuplicateGroupList(params = {}) {
  const { pageNo = 1, pageSize = 10, startTime, endTime } = params || {};
  const req = { pageNo, pageSize, startTime, endTime };
  return queryDuplicateGroupList(req).then(res => {
    if (res && res.result === 1) {
      return res.data || {};
    }
    return {};
  });
}

// 重复清理：批量合并平台资料（服务层直接返回布尔结果）
export function mergeRepeatItems(data = {}) {
  return mergeDuplicateItems(data).then(res => {
    return res && res.result === 1;
  });
}

export function deleteRepeatItems(baseItemIds = []) {
  return deleteRepeatItemsApi({ baseItemIds }).then(res => {
    return res && res.result === 1;
  });
}

// 重复清理：获取所有重复记录的 ID 和 baseItemIds（服务层直接返回数组）
export function getRepeatItemIdsList(data = {}) {
  return getRepeatItemIds(data).then(res => {
    if (res && res.result === 1) {
      return res.data || [];
    }
    return [];
  });
}

// 判断加入分销商品款式编码是否已经存在
export function getCheckDistributionOuterId(data) {
  return checkDistributionOuterId(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    } else {
      return false;
    }
  });
}

// 单独通过baseItemId请求分销价和库存
export function getPriceAndStockAlone(data) {
  return getPriceAndStock(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    } else {
      return false;
    }
  });
}

export function mapErpItems(data) {
  const mapData = {};
  mapData.addScmBaseItem =  data.addScmBaseItem ? data.addScmBaseItem : [];
  mapData.updateScmBaseItem = data.updateScmBaseItem ? data.updateScmBaseItem : [];
  mapData.addScmBaseSku = data.addScmBaseSku ? data.addScmBaseSku : [];
  mapData.updateScmBaseSku = data.updateScmBaseSku ? data.updateScmBaseSku : [];
  mapData.allowedJoinXd = data.allowedJoinXd ? data.allowedJoinXd : false;
  return mapData
}


// 汉子转拼音
export function getPinyinArr(arr) {
  return pinyin(arr).then((res) => {
    if (res.result === 1) {
      return res.data;
    } else {
      return false;
    }
  });
}

// 查询平台类目
export function getPlatformCategoryByCidAndLv(
  cid,
  level,
  platform = "kuaishou"
) {
  return getPlatformCategoryTree(
    {
      parentId: cid,
      endLevel: level + 1,
    },
    platform
  ).then((res) => {
    if (res.result === 1) {
      return res.data;
    } else {
      return false;
    }
  });
}

// 搜索类目信息
export function getCategoryList(data) {
  return queryCategoryList(data).then((res) => {
    if (res.result === 1) {
      return res.data || [];
    } else {
      return false;
    }
  });
}

// 查询天猫平台类目
// 由于天猫平台需要多传一个shopId的参数，所以用此方法包裹下，返回一个查询的方法
export function getTMCategoryFn(shopId) {
  return function getTMCategoryByCidAndLv(cid, level, platform = "tm") {
    return getPlatformCategoryTree(
      {
        parentId: cid,
        endLevel: level + 1,
        shopId,
      },
      platform
    ).then((res) => {
      if (res.result === 1) {
        return res.data;
      } else {
        return false;
      }
    });
  };
}

export function setMainCategoryList(data) {
  return setMainCategory(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}

// 查询已设置的主营类目
export function getMainCategoryList() {
  return getMainCategory().then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}

// 查询基础顶级及1级类目
export function getBaseCategoryTopAnd1() {
  return getCategoryTree({
    startLevel: 0,
    endLevel: 1,
  }).then((res) => {
    if (res.result === 1) {
      return res.data;
    } else {
      return false;
    }
  });
}
// 查询当前基础类目的子类目列表
export function getCategoryListByCidAndLv(cid, level) {
  return getCategoryTree({
    parentId: cid,
    endLevel: level + 1,
  }).then((res) => {
    if (res.result === 1) {
      return res.data;
    } else {
      return false;
    }
  });
}

// 获取类目查询条件
export function getCategoryOptions() {
  return getCompanyCategory().then((res) => {
    if (res.result === 1) {
      return res.data;
    } else {
      return false;
    }
  });
}

// 获取类目查询条件
export function getSubAccountOptions() {
  return getSubAccount().then((res) => {
    if (res.result === 1) {
      return res.data;
    } else {
      return false;
    }
  });
}

// 获取类目查询条件
export function getFindgoodscategory() {
  return findgoodscategory().then((res) => {
    if (res.result === 1) {
      return res.data;
    } else {
      return false;
    }
  });
}

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
function _formatGoodsItem(r, isRequest) {
  if (r.skuList && r.skuList.length > 0) {
    r.skuList = r.skuList.map((item) => {
      return isRequest
        ? {
            ...item,
            skuSpecifications: safeStringify(
              item.skuSpecifications ? item.skuSpecifications : [],
              '[]'
            ),
          }
        : {
            ...item,
            skuSpecifications: item.skuSpecifications
              ? safeParse(item.skuSpecifications, [])
              : [],
          };
    });
  }
  ///////////////////////////
  let itemUrl = r.itemUrl;
  let isArray = false;
  if (!isRequest) {
    try {
      // pdd 会返回[]类型, 如果为数组类型, 则不显示
      const itemUrlTemp = JSON.parse(itemUrl);
      if (Array.isArray(itemUrlTemp)) {
        isArray = true;
      }
    } catch (e) {
      // console.error(e)
    }
  }
  // itemUrl
  return isRequest
    ? {
        ...r,
        canPublishPlatform: safeStringify(r.canPublishPlatform ? r.canPublishPlatform : [], '[]'),
        mainImages: safeStringify(r.mainImages ? _filterInvalidImg(r.mainImages) : [], '[]'),
        mainImages34: r.mainImages34?.length ? r.mainImages34.join('|') : '',
        whiteBackGroundPic: r.whiteBackGroundPic?.length ? r.whiteBackGroundPic.join('|') : '',
        detailImages: safeStringify(r.detailImages ? _filterInvalidImg(r.detailImages) : [], '[]'),
        specificationNames: safeStringify(r.specificationNames ? r.specificationNames : [], '[]'),
        specifications: safeStringify(r.specifications ? r.specifications : [], '[]'),
        importCompanyInfo: r.importCompanyInfo?.join(','),
        categoryIds: r.categoryIds ? r.categoryIds.join(",") : "",
        materialImage: safeStringify(r.materialImage ? _filterInvalidImg(r.materialImage) : [], '[]'),
      }
    : {
        ...r,
        canPublishPlatform: r.canPublishPlatform
          ? safeParse(r.canPublishPlatform, [])
          : [],
        mainImages: r.mainImages ? safeParse(r.mainImages, []) : [],
        mainImages34: r.mainImages34 ? r.mainImages34.split('|') : [],
        whiteBackGroundPic: r.whiteBackGroundPic ? r.whiteBackGroundPic.split('|') : [],
        detailImages: r.detailImages ? safeParse(r.detailImages, []) : [],
        specificationNames: r.specificationNames
          ? safeParse(r.specificationNames, [])
          : [],
        specifications: r.specifications ? safeParse(r.specifications, []) : [],
        importCompanyInfo: r.importCompanyInfo ? r.importCompanyInfo?.split(',') : [],
        categoryIds: r.categoryIds ? r.categoryIds.split(",") : [],
        itemUrl: isArray ? "" : itemUrl,
        syncContent: r.syncContent ? r.syncContent : [],
        skuSpecifications: r.skuSpecifications ? safeParse(r.skuSpecifications, []) : [],
        materialImage: r.materialImage ? safeParse(r.materialImage, []) : [],
      };
}
// 格式化商品列表查询后的列表数据
function _formatGoodsList(records) {
  return records.map((item) => _formatGoodsItem(item));
}
// 商品列表查询
export function getGoodsList(data) {
  if (data.outerIds) {
    data.outerIds = data.outerIds.split(",");
  } else {
    delete data.outerIds
  }

  if (data.skuOuterIds) {
    data.skuOuterIds = data.skuOuterIds.split(",");
  }else {
    delete data.skuOuterIds
  }
  data.companyNames = data.companyNames ? data.companyNames.split(",") : [];
  data.shopNames = data.shopNames ? data.shopNames.split(",") : [];

  return getItemBasePage(data).then((res) => {
    if (res.result === 1) {
      return {
        ...res.data,
        records: res.data.records ? _formatGoodsList(res.data.records) : [],
      };
    }
    return false;
  }).catch(() => {
    return false;
  });
}
export function getGroupPublishCartList(data) {
  return getPublishCartList(data).then((res) => {
    if (res.result === 1) {
      return {
        data: _formatGoodsList(res?.data || []),
      };
    }
    return [];
  });
}

// 商品规格列表查询
export function getGoodsSkuList(data) {
  if (data.outerIds) {
    data.outerIds = data.outerIds.split(",");
  }

  if (data.skuOuterIds) {
    data.skuOuterIds = data.skuOuterIds.split(",");
  }
  data.companyNames = data.companyNames ? data.companyNames.split(",") : [];
  data.shopNames = data.shopNames ? data.shopNames.split(",") : [];

  return getItemBaseSkuPage(data).then((res) => {
    if (res.result === 1) {
      return {
        ...res.data,
        records: res.data.records ? _formatGoodsList(res.data.records) : [],
      };
    }
    return false;
  });
}

// 查询erp库存
export function getErpStockList(data) {
  return getBaseItemErpStockList(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}
// 查询sku erp库存
export function getSkuErpStockList(data) {
  return getBaseItemSkuErpStockList(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}
// 查询商品销量
export function getOrderNumList(data) {
  return getBaseItemOrderNumList(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}
// 查询SKU销量
export function getSkuOrderNumList(data) {
  return getBaseItemSkuOrderNumList(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}


// 获取基础商品详情
export function getGoodsBaseInfo(id, { otherParams, isDistributor} = {}) {
  return detailByBaseItemId({ baseItemId: id, ...otherParams }).then((res) => {
    if (res.result === 1 && res.data) {
      return _formatGoodsItem(res.data);
    }
    return false;
  });
  // if(!!isDistributor){
    
  // } else {
  //   return getItemBaseDetail({ id }).then((res) => {
  //     if (res.result === 1) {
  //       return _formatGoodsItem(res.data);
  //     }
  //     return false;
  //   });
  // }
}
// 复制商品平台资料
export function copyPlatformInfo(params) {
  return copyPlatformInfoApi(params).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}

// 编辑基础商品详情 checkOpenSync(表示是否检查"同步创建ERP资料配置")
export function editGoodsBaseInfo(data, checkOpenSync=false) { 
  const _data = _formatGoodsItem(data, true);
  const params = {
    item: _data,
    checkOpenSync:true,
    skipAddItemToErp: data.skipAddItemToErp || false,
  }

  return editItemBaseDetail(params).then((res) => {
    if (res.result === 1) {
      return res.data || true;
    }
    return false;
  });
}

// 批量修改商品名称
export function getBatchUpdateTitle(data) {
  return batchUpdateTitle(data).then((res) => {
    return res;
  });
}
// 查询kmt_erp商品信息
export function getBueryKmtErpItem(data) {
  return queryKmtErpItem(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}
// 提交手动绑定kmt和erp商品任务
export function submitKmtErpItem(data) {
  return submitChangeKmtErpItem(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}
// 查询kmt供分销商品数据
export function getItemMatchFxReleation(data) {
  return queryItemMatchFxReleation(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}

// 查询kmt供分销商品数据（供销商）
export function getSupplierItemMatchFxReleation(data) {
  return supplierQueryItemMatchFxReleation(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}

// 自动绑定kmt 供分销商品
export function autoBindKmtFxItem(data) {
  return autoBindKmtItem(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}
// 手动绑定kmt 供分销商品
export function manualBindKmtFxItem(data) {
  return manualBindKmtItem(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}
// 提交读取对应表关系建立快麦通商品和ERP商品的关联关系任务
export function submitReadFxItemRelation(data) {
  return platformItemReleation(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}
export function submitReadFxItemSkuRelation(data) {
  return platformItemSkuReleation(data).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
    return false;
  });
}
// 批量修改商品名称进度条
export function getBatchUpdateTitleProgress(data) {
  return batchUpdateTitleProgress(data).then((res) => {
    return res;
  });
}

// 批量修改分销/私密状态
export function batchState(data) {
  return updateBatchState(data).then((res) => {
    if(res.result === 1) {
      return res.data || {}
    }
    return false
  });
}

// 批量设置可见状态
export function getBatchUpdatePrivacy(data) {
  return batchUpdatePrivacy(data).then((res) => {
    if(res.result === 1) {
      return res.data || {}
    }
    return false
  });
}

// 提报货源
export function putGoodsBatch(data) {
  return putBatch(data).then((res) => {
    return res.result === 1 ? true : false;
  });
}

// 批量删除商品
export function delBatchItems(data) {
  return delBatch(data).then((res) => {
    return res.result === 1 ? true : false;
  });
}

// 基础商品批量修改类目
export function batchBaseCategory(data) {
  return updateBatchCategory(data).then((res) => {
    return res.result === 1 ? true : false;
  });
}

// 铺货
export function publishGoods(data, url) {
  if(!publishLimit(data?.itemIds?.length || 1)){
    return false;
  }
  return distributorPublish(data, url).then(res=> {
    if(res.result === 1){
      return res.data || true
    } else {
      return false
    }
  })
}
// 批量铺货----支持加分销+铺货
export function batchPublishGoods(data, url) {
    return batchDistributorPublish(data, url).then(res=> {
      if(res.result === 1){
        return res.data || true
      } else {
        return false
      }
    })
  }
export function publishGoodsResult(data, url) {
  // 铺货接口查询
  return publishItemsResult(data, url).then((res) => {
    if (res.result === 1) {
      return res.data;
    }
  });
}

export function publishConfirmValid_v2(data) {
  // 铺货接口查询
  return secConfirmationItemV2(data).then((res) => {
    if (res.result === 1) {
      return res.data || [];
    } else {
      return []
    }
  });
}


// 获取常用规格
export function getUsualSpecification(specificationName) {
  return queryCommonlySpecifications({specificationName}).then((res) => {
    if (res.result === 1) {
      return res.data || [];
    } else {
      return false;
    }
  });
}

// 编辑常用规格模版
export function editUsualSpecification(data) {
  return editCommonlySpecifications(data).then(res => res.result === 1);
}
// 删除常用规格模版
export function deleteUsualSpecification(data) {
  return deleteCommonlySpecifications(data).then(res => res.result === 1);
}

// 拼款铺货
export function groupProdsOnSelf(data) {
  return groupOnShelf(data).then((res) => {
    if (res.result === 1) {
      return res.data || true;
    }
    return '';
  });
}
// 拼款铺货-获取skuList--（替换下面两个）
export function getPieceItemSkuList(data,source) {
  return queryPieceItemSkuList(data).then((res) => {
    if (res.result === 1) {
      return res.data || [];
    } else {
      return [];
    }
  });
}
// 拼款铺货-获取skuList
export function getSkuList(data,source) {
  if(source == 'jd') {
    return getSkuListByJd(data).then((res) => {
      if (res.result === 1) {
        return res.data || [];
      } else {
        return [];
      }
    });
  }
  return getSkus(data).then((res) => {
    if (res.result === 1) {
      return res.data || [];
    } else {
      return [];
    }
  });
}

// 供销商小店中的拼款铺货-获取skuList
export function getSupplierSkuList(data) {
  return getSupplierSkus(data).then((res) => {
    if (res.result === 1) {
      return res.data || [];
    } else {
      return [];
    }
  });
}

// 供销商-设置/取消供销商品
export function setProdDistributionGoods(data) {
  return setDistributionGoods(data).then((res) => {
    if (res.result === 1) {
      return res.data || false;
    } else {
      return false;
    }
  });
}

// 供销商-供销商品列表查询
export function prodDistributionGoodsList(data) {
  if (data.outerIds) {
    data.outerIds = data.outerIds.split(",");
  }
  if (data.skuOuterIds) {
    data.skuOuterIds = data.skuOuterIds.split(",");
  }
  return distributionGoodsList(data).then((res) => {
    if (res.result === 1) {
      return {
        ...res.data,
        records: res.data.records ? _formatGoodsList(res.data.records) : [],
      };
    }
    return false;
  })
}

// 供销商-批量修改分销价接口（sku）
export function prodBatchEditDistributionPrice(data) {
  return batchEditDistributionPrice(data).then((res) => {
    if (res.result === 1) {
      return true;
    } else {
      return false;
    }
  });
}

// 供销商-设置分销价格列表查询
export function prodFindItemDistributionPrice(data) {
  return findItemDistributionPrice(data).then((res) => {
    if (res.result === 1) {
      return res.data || false;
    } else {
      return false;
    }
  });
}

export function prodItemSkusDistributionPriceSave(data) {
  return itemSkusDistributionPriceSave(data).then((res) => {
    if (res.result === 1) {
      return true;
    } else {
      return false;
    }
  });
}

// 分销商- 导入商品中心查看同步任务结果
export function prodQueryJobResult(data) {
  return queryJobResult(data).then((res) => {
    if (res.result === 1) {
      return res.data || false;
    } else {
      return false;
    }
  });
}

// 获取加入分销商品的结果
export function getJoinDistributorItemResult(data) {
  return joinDistributorItemResult(data).then((res) => {
    if (res.result === 1) {
      return res.data || false;
    } else {
      return false;
    }
  });
}

// 分销商-供销商展架
export function prodDisplayGoodsList(data) {
  if (data.outerIds) {
    data.outerIds = data.outerIds.split(",");
  }
  if (data.skuOuterIds) {
    data.skuOuterIds = data.skuOuterIds.split(",");
  }
  return displayGoodsList(data).then((res) => {
    if (res.result === 1) {
      return {
        ...res.data,
        records: res.data.records ? _formatGoodsList(res.data.records) : [],
      };
    }
    return false;
  })
}

// 分销商-查看供销商商品列表
export function prodSupplierGoodsList(data) {
  if (data.outerIds) {
    data.outerIds = data.outerIds.split(",");
  }
  if (data.skuOuterIds) {
    data.skuOuterIds = data.skuOuterIds.split(",");
  }
  return supplierPromotionShopItemList(data).then((res) => {
    if (res.result === 1) {
      return {
        ...res.data,
        records: res.data.records ? _formatGoodsList(res.data.records) : [],
      };
    }
    return false;
  })
}

// 分销商-转分销订单-查看供销商商品列表
export function tradeChangeProdSupplierGoodsList(data, searchType) {
  if (data.outerIds) {
    data.outerIds = data.outerIds.split(",");
  }
  if (data.skuOuterIds) {
    data.skuOuterIds = data.skuOuterIds.split(",");
  }
  const requestFn = searchType === 'supplierSearch' ? getKmtfxSupplierItemList : tradeChangeSupplierPromotionShopItemList;
  return requestFn(data).then((res) => {
    if (res.result === 1) {
      return {
        ...res.data,
        records: res.data.records ? _formatGoodsList(res.data.records) : [],
      };
    }
    return false;
  })
}

// 分销商-查看供销商商品列表
export function shareSupplierGoodsList(data) {
  if (data.outerIds) {
    data.outerIds = data.outerIds.split(",");
  }
  if (data.skuOuterIds) {
    data.skuOuterIds = data.skuOuterIds.split(",");
  }
  return sharePromotionShopItemList(data).then((res) => {
    if (res.result === 1) {
      return {
        ...res.data,
        records: res.data.records ? _formatGoodsList(res.data.records) : [],
      };
    }
    return false;
  })
}

// 商品列表查询
export function qureyItemDistributorPage(data) {
  if (data.outerIds) {
    data.outerIds = data.outerIds.split(",");
  }
  if (data.skuOuterIds) {
    data.skuOuterIds = data.skuOuterIds.split(",");
  }
  return itemDistributorPage(data).then((res) => {
    if (res.result === 1) {
      return {
        ...res.data,
        records: res.data.records ? _formatGoodsList(res.data.records) : [],
      };
    }
    return false;
  });
}
// 商品列表查询-sku
export function qureyItemDistributorPageSku(data) {
  if (data.outerIds) {
    data.outerIds = data.outerIds.split(",");
  }
  if (data.skuOuterIds) {
    data.skuOuterIds = data.skuOuterIds.split(",");
  }
  return itemDistributorPageSku(data).then((res) => {
    if (res.result === 1) {
      return {
        ...res.data,
        records: res.data.records ? _formatGoodsList(res.data.records) : [],
      };
    }
    return false;
  });
}

// 商品资料、铺货or组合铺货，获取多个基础商品详情列表
export function prodDetailByBaseItemIds(data) {
  return detailByBaseItemIds(data).then((res) => {
    if (res.result === 1) {
      if(res.data && res.data.length) {
        return _formatGoodsList(res.data)
      }
      return false
    }
    return false;
  });
}

// 分销商品详情
export function prodDistributorDetail(data) {
  return distributorDetail(data).then(res => {
    if(res.result === 1) {
      if(res.data) {
        return  _formatGoodsItem(res.data)
      }
      return false
    }
    return false
  })
}

// 获取店铺授权信息
export function prodGetWarning(data) {
  return getWarning(data).then(res=> {
    if(res.result === 1) {
      return res.data || false
    }
    return false
  })
}

// 添加供销商
export function prodSupplierAdd(data) {
  return supplierAdd(data).then(res => {
    if(res.result === 1) {
      return true
    }
    return  false
  })
}

// 采购供销商列表
export function getCgSupplierList(data) {
  return cgSupplierList(data).then(res => {
    if(res.result === 1) {
      return res.data || false
    }
    return false
  })
}

// 同步平台资料
export function getSyncPlatformItem(data) {
  return syncPlatformItem(data).then(res=> {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
// 批量同步平台资料
export function getBatchSyncPlatformItem(data) {
  return batchSyncPlatformItem(data).then(res=> {
    if(res.result === 1) {
      return res
    }
    return false
  })
}

// 加入分销商品
export function getJoinDistributorItem(data) {
  return joinDistributorItem(data).then((res) => {
    if (res.result === 1) {
      return true;
    } else {
      return false;
    }
  });
}

// 批量商品同步，比较数据差异
export function getCheckSyncItems(data) {
  return checkSyncItems(data).then(res=> {
    if(res.result === 1) {
      return mapCheckErpItems(res.data)
    }
    return false
  })
}
// 批量商品同步，比较数据市场价差异
export function getCheckSyncMarketItems(data) {
  return checkSyncMarketItems(data).then(res=> {
    if(res.result === 1) {
      return mapCheckErpItems(res.data)
    }
    return false
  })
}

// 提交批量商品同步任务
export function getSubmitSyncItemTask(data) {
  return submitSyncItemTask(data).then(res=> {
    if(res.result === 1) {
      return true
    }
    return false
  })
}

// 获取小程序二维码
export function getGenerateQrCodeUrl(data) {
  return generateQrCodeUrl(data).then(res => {
    if(res.result === 1) {
      return res.data || false
    }
    return false
  })
}

// 获取智能匹配的类目/属性
// export function getCategoryAndPropertiesMatch(data) {
//   return categoryAndPropertiesMatch(data).then(res => {
//     if(res.result === 1) {
//       return res.data || false
//     }
//     return false
//   })
// }

export function mapCheckErpItems(data) {
  const mapData = {};
  mapData.addItemList =  data.addItemList ? data.addItemList : [];
  mapData.addSkuList = data.addSkuList ? data.addSkuList : [];
  mapData.updateItemList = data.updateItemList ? data.updateItemList : [];
  mapData.updateSkuList = data.updateSkuList ? data.updateSkuList : [];
  mapData.diffValueList = data.diffValueList ? data.diffValueList : [];
  return mapData
}

// 一键生成平台资料
export function oneClickCreatePlatformItem(data, url) {
  return fastMergePlatformItem(data, url).then(res => {
    if(res.result === 1){
      return res.data
    }else{
      return false
    }
  })
}
export function getPlatformItemProgress(data, url) {
  return fastMergePlatformItemProgress(data, url).then(res => {
    if(res.result === 1){
      return res.data
    }else{
      return false
    }
  })
}
// 同步商品分类]
export function getAutoSyncCategoryToKmt(data) {
  return queryAutoSyncCategoryToKmt(data).then(res => {
    if(res.result === 1) {
      return res.data || 0
    }
    return 0
  })
}
export function batchUpdateAutoSyncCategoryToKmt(data) {
  return updateAutoSyncCategoryToKmt(data).then(res => {
    if(res.result === 1) {
      return true
    }
    return false
  })
}
export function checkDownloadAutoJoinShop(data) {
  return checkDownloadAutoJoinShopApi(data).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}

// 获取sku统计结果
export function getTotalSkuExt(data) {
  return getTotalSkuExtApi(data).then(res=> {
    if(res.result === 1) {
      return res.data || false
    }
    return false
  })
}

//标记成我已处理
export function markMainImagesChange(data) {
  return markMainImagesChangeApi(data).then(res=> {
    if(res.result === 1) {
      return res.data || false
    }
    return false
  })
}
//批量更新商品主图

export function batchUpdateMainImages(data) {
  return batchUpdateMainImagesApi(data).then(res=> {
    if(res.result === 1) {
      return true
    }
    return false
  })
}
// 分销商品sku详情
export function skuInfoList(data) {
  return skuInfoListApi(data).then(res=> {
    if(res.result === 1) {
      return res.data || false
    }
    return false
  })
}
export function serviceEditItemLinkList(data) {
  return getEditItemLinkList(data).then(res=> {
    if(res.result === 1) {
      return res.data || false
    }
    return false
  })
}
export function batchEditItemPic(data) {
  return batchEditItemPicApi(data).then(res=> {
    if(res.result === 1) {
      return true
    }
    return false
  })
}
export function getSizeMapping(data) {
  return sizeMapping(data).then(res=> {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
export function batchFixImages(data) {
  // 入参可参考下面接口文档
  // https://s.apifox.cn/3524ecae-2eda-4956-bca8-e454e8d4570b/404601162e0
  return batchResizeImages(data).then(res=> {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
